import React from "react";
import { DivWrapper } from "./sections/DivWrapper/DivWrapper";
import { Hero } from "./sections/Hero/Hero";
import { Nav } from "./sections/Nav/Nav";
import { Roadassist } from "./sections/Roadassist/Roadassist";
import { View } from "./sections/View/View";
import { ViewWrapper } from "./sections/ViewWrapper/ViewWrapper";
import { Navbar2 } from "./sections/Nav2/Navbar2";
import Footer from "./sections/Footer/Footer";
import "./style.css";

export const Desktop = () => {
    return (
        <div className="desktop">
            <Navbar2 />
            <Nav />
            <Hero />
            <DivWrapper />
            <Roadassist />
            <ViewWrapper />
            <View />



            <Footer />
        </div>
    );
};
